import { useEffect, useState } from 'react';

const useCheckServerAddress = () => {
    const [ serverAddress, setServerAddress ] = useState(typeof (window.CONFIG) !== 'undefined' ? window.CONFIG.ServerAddress : '');

    useEffect(() => {
        if (typeof (window.CONFIG) !== 'undefined') {
            if (window.CONFIG.ServerAddress && (serverAddress === 'localhost' || serverAddress === '127.0.0.1')) {
                window.CONFIG.ServerAddress = window.location.hostname;
                setServerAddress(window.location.hostname);
            }
        }
    }, []);

    return serverAddress;
}

export default useCheckServerAddress;